export const LockedFolder = ({
  size = "24",
  ...props
}: {
  size?: string;
} & React.SVGProps<SVGSVGElement>) => {
  return (
    <>
      <span className="t-sr-only">Locked Folder</span>
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 56 56"
        fill="none"
      >
        <path
          d="M28 17.5H47.25C47.7141 17.5 48.1592 17.6844 48.4874 18.0126C48.8156 18.3408 49 18.7859 49 19.25V43.75C49 44.2141 48.8156 44.6593 48.4874 44.9874C48.1592 45.3156 47.7141 45.5 47.25 45.5H8.75C8.28587 45.5 7.84075 45.3156 7.51256 44.9874C7.18437 44.6593 7 44.2141 7 43.75V22.75"
          fill="#FFC400"
        />
        <path
          d="M20.4094 22.75H7V14C7 13.5359 7.18437 13.0908 7.51256 12.7626C7.84075 12.4344 8.28587 12.25 8.75 12.25H20.4094C20.7878 12.2516 21.1557 12.3742 21.4594 12.6L28 17.5L21.4594 22.4C21.1557 22.6258 20.7878 22.7484 20.4094 22.75Z"
          fill="#FFAB00"
        />
        <g clipPath="url(#clip0_685_46545)">
          <path
            d="M50.9998 35H36.9998C35.7998 43.4 41.1665 47.1667 43.9998 48C51.1998 45.2 51.6665 38.1667 50.9998 35Z"
            fill="white"
          />
          <path
            d="M51.5 31.75H36.5C36.1022 31.75 35.7206 31.908 35.4393 32.1893C35.158 32.4706 35 32.8522 35 33.25V38.7597C35 47.1606 42.1081 49.9478 43.5312 50.4212C43.8352 50.5246 44.1648 50.5246 44.4688 50.4212C45.8938 49.9478 53 47.1606 53 38.7597V33.25C53 32.8522 52.842 32.4706 52.5607 32.1893C52.2794 31.908 51.8978 31.75 51.5 31.75ZM48.2806 38.2806L43.0306 43.5306C42.961 43.6004 42.8783 43.6557 42.7872 43.6934C42.6962 43.7312 42.5986 43.7506 42.5 43.7506C42.4014 43.7506 42.3038 43.7312 42.2128 43.6934C42.1217 43.6557 42.039 43.6004 41.9694 43.5306L39.7194 41.2806C39.5786 41.1399 39.4996 40.949 39.4996 40.75C39.4996 40.551 39.5786 40.3601 39.7194 40.2194C39.8601 40.0786 40.051 39.9996 40.25 39.9996C40.449 39.9996 40.6399 40.0786 40.7806 40.2194L42.5 41.9387L47.2194 37.2194C47.2891 37.1497 47.3718 37.0944 47.4628 37.0567C47.5539 37.019 47.6515 36.9996 47.75 36.9996C47.8485 36.9996 47.9461 37.019 48.0372 37.0567C48.1282 37.0944 48.2109 37.1497 48.2806 37.2194C48.3503 37.2891 48.4056 37.3718 48.4433 37.4628C48.481 37.5539 48.5004 37.6515 48.5004 37.75C48.5004 37.8485 48.481 37.9461 48.4433 38.0372C48.4056 38.1282 48.3503 38.2109 48.2806 38.2806Z"
            fill="#5622FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_685_46545">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(32 28)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
